import { Dispatch } from 'react-redux';
import { ActionTypes } from "./action-types";
import { AuthActionCreators, IApplicationState } from "../";
import { ISwapTracker } from "../../models";

export interface ISwapTrackerListResponse {
    data: {
        success: boolean,
        message: string,
        results: ISwapTracker[]
    }
}

export const ActionCreators = {
    getSwaps: (isOps: boolean) => (dispatch: Dispatch<IApplicationState>): Promise<ISwapTrackerListResponse> => {
        var options = {
            url: !isOps ? __API__ + '/swap/swap-tracker' : __API__ + '/public/command-center/swap-tracker'
        };

        if (!isOps) {
            return dispatch(AuthActionCreators.apiGet(options)).then((response: ISwapTrackerListResponse) => {
                if (response.data.success)
                    dispatch(ActionCreators.setSwaps(response.data.results));

                return Promise.resolve(response);
            });
        } else {
            return dispatch(AuthActionCreators.apiGetPublic(options)).then((response: ISwapTrackerListResponse) => {
                if (response.data.success)
                    dispatch(ActionCreators.setSwaps(response.data.results));

                return Promise.resolve(response);
            });
        }
    },
    setSwaps: (list: ISwapTracker[]) => {
        return {
            type: ActionTypes.SET_SWAP_TRACKER_SWAPS,
            list
        };
    }
};
